import { ProductionReportView } from "@/features/production-report";

// Spec 083 (T044) — a aba do detalhe da linha.
//
// É o MESMO componente da tela dedicada, com o recorte travado nesta linha. Duplicar a composição
// aqui criaria duas telas que divergem na primeira mudança — e o gestor veria números diferentes
// para o mesmo período conforme a porta de entrada.
export function LineProductionReportTab({ lineId }: { lineId: string }) {
  return <ProductionReportView lockedLineId={lineId} />;
}
